import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserService } from "./user.service";
import { constants } from "../constants";
import { Login } from "../models/login.model";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class LoginService {

  private static readonly AUTH_TOKEN: string = 'auth-token';
  private static readonly AUTH_URL: string = `${constants.BASE_URL}/api/auth`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService
  ) { }

  isAuthenticated(): boolean {
    return localStorage.getItem(LoginService.AUTH_TOKEN) != null;
  }

  getAuthToken(): any {
    const authToken: string | null = localStorage.getItem(LoginService.AUTH_TOKEN);
    return authToken ? { [LoginService.AUTH_TOKEN]: authToken } : null;
  }

  getAuthUrl(): string {
    return LoginService.AUTH_URL;
  }

  getSsoLoginUrl(): string {
    return environment.ssoUrl;
  }

  login(login: Login): Observable<void> {
    return this.http.post<HttpResponse<void>>(LoginService.AUTH_URL, login, { observe: 'response' as 'body', responseType: 'text' as 'json' })
      .pipe(map((response: HttpResponse<void>) => {
        this.onLoginSuccess(response.headers.get(LoginService.AUTH_TOKEN)!);
      }));
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  onLoginSuccess(token?: string) {
    if (token) {
      localStorage.setItem(LoginService.AUTH_TOKEN, token);
    }
    this.userService.getCurrentUser();
  }

}
